<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.00004 1.33325C4.00004 1.33325 4.54866 1.86432 4.87603 1.99992C5.2034 2.13552 5.88566 2.1143 5.88566 2.1143C5.88566 2.1143 5.86341 2.83099 6.00004 3.16084C6.13667 3.49069 6.66671 3.99992 6.66671 3.99992C6.66671 3.99992 6.13431 4.47951 6.00004 4.80367C5.86577 5.12783 5.88566 5.88554 5.88566 5.88554C5.88566 5.88554 5.17849 5.85183 4.82097 5.99992C4.46345 6.14801 4.00004 6.66659 4.00004 6.66659C4.00004 6.66659 3.29162 6.05518 3.1582 5.99992C2.83437 5.86578 2.11442 5.88554 2.11442 5.88554C2.11442 5.88554 2.14286 5.14847 2.00004 4.80367C1.85722 4.45887 1.33337 3.99992 1.33337 3.99992C1.33337 3.99992 1.92541 3.47915 2.05726 3.16084C2.18911 2.84254 2.11442 2.1143 2.11442 2.1143C2.11442 2.1143 2.84012 2.13167 3.1582 1.99992C3.47629 1.86816 4.00004 1.33325 4.00004 1.33325Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.77627 3.46655L3.71882 4.62014L3.23816 4.09578"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
